import Config from "services/config/config";
import callWebService, {
  callTypes
} from "services/utils/networks/network";
import {CREDITS_LIST, TEAMS_LIST} from "./type";

export const creditListing = (type,page,department_id=null,team_id=null,employee_name=null) => async (dispatch) => {
  try {
    let url = `${Config.creditPolicy.getCredits}?type=${type}&page=${page}`;

    if (employee_name !== null && employee_name !== undefined) {
        url += `&employee_name=${employee_name}`;
    }

    if (department_id !== null && department_id !== undefined) {
        url += `&department_id=${department_id}`;
    }
    if (team_id !== null && team_id !== undefined) {
      url += `&team_id=${team_id}`;
    }
    const res = await callWebService(
      callTypes.get,
      {},
      url
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: CREDITS_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    return false;
  }
};

export const teamListing = () => async (dispatch) => {
  try {
    let url = `${Config.creditPolicy.getEmployeeTeamList}`;

    const res = await callWebService(
      callTypes.get,
      {},
      url
    );

    if (res) {
      const { data } = res;
      dispatch({
        type: TEAMS_LIST,
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    return false;
  }
};